import { render, staticRenderFns } from "./CourtForm.vue?vue&type=template&id=bff99b2e"
import script from "./CourtForm.vue?vue&type=script&lang=js"
export * from "./CourtForm.vue?vue&type=script&lang=js"
import style0 from "./CourtForm.vue?vue&type=style&index=0&id=bff99b2e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports